import React from 'react';
import './Common.css';

/**
 * Loader component for displaying loading state
 * 
 * @param {Object} props
 * @param {string} props.size - Size of loader (small, medium, large)
 * @param {string} props.color - Color of the loader
 * @param {string} props.className - Additional class name for styling
 * @returns {JSX.Element}
 */
const Loader = ({ 
  size = 'medium',
  color = 'primary',
  className = '',
  ...restProps 
}) => {
  return (
    <div 
      className={`loader loader-${size} loader-${color} ${className}`}
      {...restProps}
    >
      <div className="loader-spinner"></div>
    </div>
  );
};

export default Loader; 